export const getDefault = () => {
  const schema = {
    name: 'Gallery',
    imagesMode: 'noLink',
    hasTheater: true,
    hasLink: true,
    title: 'Galeria de imagens',
    hasDescription: true,
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    columns: 4,
    images: [
      {
        src: 'https://images.pexels.com/photos/3031075/pexels-photo-3031075.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500',
        alt: 'Imagem sem alt',
        hasTitle: true,
        title: 'Título da imagem',
        hasLink: false,
        description:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
      },
      {
        src: 'https://static.ua.pt/images/ua/placeholder-bw.png',
        alt: 'Imagem sem alt',
        hasTitle: true,
        title: 'Título da imagem',
        hasLink: false,
        description:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
      },
      {
        src: 'https://images.pexels.com/photos/2754200/pexels-photo-2754200.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500',
        alt: 'Imagem sem alt',
        hasTitle: true,
        title: 'Título da imagem',
        hasLink: false,
        description:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
      },
      {
        src: 'https://static.ua.pt/images/ua/placeholder-bw.png',
        alt: 'Imagem sem alt',
        hasTitle: true,
        title: 'Título da imagem',
        hasLink: false,
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
      },
    ]
  }
  return schema
}
